import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { useRoomContext } from '../../../../../context/RoomContext';
import { useMatrixClient } from '../../../../../context/MatrixContext';
import { useDisambiguation } from '../../../../../context/DisambiguationContext';
import './ReactionDetailsModal.css';

const ReactionDetailsModal = ({ reactions, onClose }) => {
  const [selectedEmoji, setSelectedEmoji] = useState('all');
  const { members } = useRoomContext();
  const client = useMatrixClient();
  const { needsDisambiguation } = useDisambiguation();
  const currentUserId = client?.getUserId();

  const { allEmojis, reactionsByEmoji } = useMemo(() => {
    const emojiSet = new Set();
    const byEmoji = new Map();

    reactions.forEach((reactors, emoji) => {
      emojiSet.add(emoji);
      byEmoji.set(emoji, reactors);
    });

    return {
      allEmojis: ['all', ...Array.from(emojiSet)],
      reactionsByEmoji: byEmoji,
    };
  }, [reactions]);

  const getAvatarUrl = (userId) => {
    const member = members.find(m => m.id === userId);
    return member?.avatar || '';
  };

  const renderReactors = () => {
    const elements = [];
    const emojisToRender = selectedEmoji === 'all'
      ? Array.from(reactionsByEmoji.keys())
      : [selectedEmoji];

    emojisToRender.forEach(emoji => {
      const reactors = reactionsByEmoji.get(emoji);
      if (reactors) {
        reactors.forEach(reactor => {
          elements.push(
            <div key={`${emoji}-${reactor.senderId}`} className="reaction-details-modal-user">
              <img src={getAvatarUrl(reactor.senderId)} alt={reactor.displayName} className="reaction-details-modal-avatar" />
              <span className="reaction-details-modal-name">
                {reactor.displayName}
                {reactor.senderId !== currentUserId && needsDisambiguation(reactor.senderId) && (
                  <span className="reaction-details-mxid"> ({reactor.senderId})</span>
                )}
              </span>
              <span className="reaction-details-modal-emoji">{emoji}</span>
            </div>,
          );
        });
      }
    });
    return elements;
  };

  return createPortal(
    <div className="reaction-details-modal-overlay" onClick={onClose}>
      <div className="reaction-details-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="reaction-details-modal-filters">
          {allEmojis.map(emoji => (
            <button
              key={emoji}
              className={`reaction-details-modal-filter-btn ${selectedEmoji === emoji ? 'active' : ''}`}
              onClick={() => setSelectedEmoji(emoji)}
            >
              {emoji === 'all' ? 'All' : emoji}
            </button>
          ))}
        </div>
        <div className="reaction-details-modal-list">
          {renderReactors()}
        </div>
      </div>
    </div>,
    document.body,
  );
};

ReactionDetailsModal.propTypes = {
  reactions: PropTypes.instanceOf(Map).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ReactionDetailsModal;